import Axios from 'axios';
import { baseURL } from '../config';

const axios = Axios.create({
  baseURL,
  timeout: 60000,
});
axios.interceptors.request.use((config) => {
  let accessToken = localStorage.getItem('@footab/admin/accessToken');
  let refreshToken = localStorage.getItem('@footab/admin/refreshToken');
  !!accessToken &&
    !!refreshToken &&
    (config.headers = { accessToken, refreshToken });
  return config;
});
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (!error.config?.url?.includes('/auth/')) {
      if (error.response && error.response.status === 401) {
        if (window.location.href.includes('/logout'))
          return Promise.reject(error);
        else window.location.replace(`${process.env.PUBLIC_URL}/logout`);
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
